import { Accordion, Button, TextInput } from 'flowbite-react';
import { useEffect, useState } from 'react';
import CommonApi from '../../Api/CommonApi';
import { ManualDisplay as ManualDisplayObj } from '../../Models/ManualDisplay';
import Loader from '../Common/Loader';
import { HiDownload } from 'react-icons/hi';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';
import ManufacturerApi from '../../Api/ManufacturerApi';
import { Manufacturer } from '../../Models/Manufacturer';
import { FileTypeEnums } from '../../Models/FileType';
import { OldManualList } from '../../Models/OldManualList'; // add this import

export default function ManualPage() {
  const { id } = useParams();
  const [manufacturerData, setManufacturerData] =
    useState<Manufacturer | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [oldManuals, setOldManuals] = useState<OldManualList[]>([]);
  const [expandedManufacturers, setExpandedManufacturers] = useState<
    Record<string, boolean>
  >({});
  const [expandedSubCategories, setExpandedSubCategories] = useState<
    Record<string, boolean>
  >({});

  const toggleManufacturer = (name: string) => {
    setExpandedManufacturers((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const toggleSubCategory = (key: string) => {
    setExpandedSubCategories((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  const getManufacturer = () => {
    if (id) {
      setIsLoading(true);
      ManufacturerApi.getManufacturer(id)
        .then((res) => {
          setManufacturerData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setManufacturerData(null);
    }
  };

  useEffect(() => {
    getManufacturer();
    getOldManuals();
  }, [id]);

  const getOldManuals = () => {
    if (id) {
      CommonApi.getOldManuals(id)
        .then((res) => {
          if (res.data?.length > 0) {
            setOldManuals(res.data);
          }
        })
        .catch((err) => {
          console.log('Error loading old manuals', err);
        });
    }
  };

  const grouped = oldManuals.reduce((acc, manual) => {
    const manu = manual.manufacturerName ?? 'Unknown Manufacturer';
    const sub = manual.subCategoryName ?? 'Unknown SubCategory';

    if (!acc[manu]) acc[manu] = {};
    if (!acc[manu][sub]) acc[manu][sub] = [];

    acc[manu][sub].push(manual);
    return acc;
  }, {} as Record<string, Record<string, OldManualList[]>>);

  const oldManualsBySubCategory = oldManuals.reduce((acc, manual) => {
    const sub = manual.subCategoryName ?? 'Uncategorized';
    if (!acc[sub]) acc[sub] = [];
    acc[sub].push(manual);
    return acc;
  }, {} as Record<string, OldManualList[]>);

  return (
    <div className='w-full pt-4 h-[calc(100vh-60px)] md:h-[calc(100vh-130px)] overflow-y-auto '>
      <div className='flex flex-col mx-auto p-2'>
        <div className='mb-5 pb-5 border-b-2'>
          <h1 className='text-gray-900 font-bold text-4xl pr-10 mb-5'>
            {manufacturerData?.name} Manuals
          </h1>
          <div className=''>
            {manufacturerData?.files &&
              manufacturerData.files?.filter(
                (x) => x.fileTypeId === FileTypeEnums.Photo
              ).length > 0 && (
                <img
                  width={300}
                  src={
                    manufacturerData.files.filter(
                      (x) => x.fileTypeId === FileTypeEnums.Photo
                    )[0].fileUrl!
                  }
                  className='h-24 object-contain float-left mx-5 my-2'
                />
              )}
            <div className='pr-0 lg:pr-10'>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    manufacturerData?.description ?? ''
                  ),
                }}
              />
            </div>
          </div>
        </div>
        <div className='relative'>
          {isLoading && <Loader />}
          <div className=''>
            <div className='w-full overflow-y-auto'>
              {isLoading && <p>Loading manuals...</p>}
              {oldManualsBySubCategory &&
                Object.keys(oldManualsBySubCategory).length > 0 && (
                  <Accordion>
                    {Object.entries(oldManualsBySubCategory).map(
                      ([subCategory, items]) => (
                        <Accordion.Panel key={subCategory}>
                          <Accordion.Title className='text-lg font-semibold'>
                            {subCategory}
                          </Accordion.Title>
                          <Accordion.Content>
                            <ul className='ml-4 list-disc list-inside space-y-1'>
                              {items.map((oldMan) => (
                                <li
                                  key={oldMan.id}
                                  className='italic text-gray-600'
                                >
                                  <a
                                    href={oldMan.fullUrl ?? '#'}
                                    download={oldMan.fileName}
                                    className='hover:underline'
                                    target='_blank'
                                  >
                                    {oldMan.fileName}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </Accordion.Content>
                        </Accordion.Panel>
                      )
                    )}
                  </Accordion>
                )}

              {!isLoading &&
                Object.keys(oldManualsBySubCategory).length === 0 && (
                  <div className='text-gray-900 font-bold text-2xl text-center'>
                    <p>-- No manuals found --</p>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
